export class ManateEvent {
    name;
    paths;
    constructor(name, paths) {
        this.name = name;
        this.paths = paths;
    }
    get pathString() {
        return this.paths.map((k) => k.toString()).join('+');
    }
    toString() {
        return `${this.name}: ${this.pathString}`;
    }
}
export class Child {
    emitter;
    listener;
    constructor(path, emitter, parentEmitter) {
        this.emitter = emitter;
        this.listener = (event) => {
            parentEmitter.emit('event', new ManateEvent(event.name, [path, ...event.paths]));
        };
        this.emitter.on('event', this.listener);
    }
    release() {
        this.emitter.off('event', this.listener);
    }
}
export class Children {
    children = {};
    addChild(path, emitter, parentEmitter) {
        this.releaseChild(path);
        const child = new Child(path, emitter, parentEmitter);
        this.children[path] = child;
    }
    releaseChild(path) {
        const child = this.children[path];
        if (child) {
            child.release();
            delete this.children[path];
        }
    }
    releasesAll() {
        for (const path of Object.keys(this.children)) {
            this.releaseChild(path);
        }
    }
}
